import styled, { StyledComponentClass } from 'styled-components';

const StackedListBody: StyledComponentClass<any, any> = styled.ul`
  width: 100%;
  margin: 0;
  padding: 8px;
`;

export default StackedListBody;
